export enum SupportedPlatforms {
    ORDER = 'order',
}

export enum SupportedCompanies {
    APPAREL = 'apparel',
    GAMEBREAKER = 'gamebreaker',
    P3INC = 'p3inc',
}

export enum SupportedTags {
    APPAREL_ORDER = 'apparel::order',
    GAMEBREAKER_ORDER = 'gamebreaker::order',
    P3INC_ORDER = 'p3inc::order',
}

export enum SupportedDomains {
    APPAREL_ORDER = 'https://wooter.com',
    GAMEBREAKER_ORDER = 'https://uniforms.gamebreaker.com',
    P3INC_ORDER = 'https://p3inc.wooterapparel.com',
}
